/**
 * @author      [leiling.cp]
 * @version     [0.0.1]
 * @date        [2015/8/15]
 * @description [简易的与后端建立链接的中间件]
 * @define      [保留关键字message,heart,open,close,error]
 */

var $ = require('@alife/alpha-jquery/jquery'),
    Base = require('@alife/alpha-base/base'),
    Util = require('./lib/util'),
    LocalStorageDB = require('./lib/localstorage-db'),
    EventSource = require('./lib/event-source');


var AlipushClient = Base.extend({
    attrs: {
        uid: Util.getBeaconId() || '',
        type: 'sse',
        readyState: '', // 0为CONNECTING,1为OPEN,2为CLOSED
        pingInterval: 30000,
        sid: '',
        channel: '',
        heartTime: new Date().getTime(),
        prevMsgId: '',
        forceConnect: true
    },
    initialize: function(config) {
        AlipushClient.superclass.initialize.call(this, config);

        this.connection = null;
        this.open();
    },
    uri: function(type) {
        var self = this,
            secure = /(https|wss)/.test(window.location.protocol.toString()),
            schema = '',
            hostname = 'live.alibaba.com',
            path = '',
            query = '?uid=' + self.get('uid');

        switch (type) {
            case 'sse':
                schema = secure ? 'https' : 'http';
                path = '/alipush.io/sse';
                break;
            case 'ws':
                schema = secure ? 'wss' : 'ws';
                path = '/alipush.io/ws';
                break;
            default:
                schema = secure ? 'https' : 'http';
                path = '/alipush.io/sse';
                break;
        }

        return schema + '://' + hostname + path + query;
    },
    supportSocket: function() {
        var ret = false;
        try {
            ret = !!WebSocket && !('__initialize' in WebSocket);
        } catch (e) {
            ret = false;
        }
        return ret;
    },
    open: function() {
        var self = this,
            uri = '';

        if (!self.get('uid')) {
            self.trigger('error', {
                code: 500,
                msg: 'Alibeacon id is null'
            });
            return false;
        }

        if (!!self.connection) {
            self.trigger('error', {
                code: 500,
                msg: 'There is already a connect exist.'
            });
            return false;
        }

        if (self.supportSocket()) {
            self.set('type', 'ws');
            uri = self.uri('ws');
            try {
                self.connection = new WebSocket(uri);
            } catch (error) {
                self.trigger('error', error);
                return false;
            }
        } else {
            uri = self.uri('sse');
            try {
                self.connection = new EventSource(uri);
            } catch (error) {
                self.trigger('error', error);
                return false;
            }
        }

        Util.debug('[open] ' + uri);
        self.addEventListeners();
    },
    close: function(forceClose) {
        var self = this;

        if (!self.connection) {
            return false;
        }

        self.connection.close();
        self.connection = null;

        if (forceClose) {
            return true;
        }
        if (self.get('forceConnect')) {
            self.open();
        }
    },
    emit: function(message) {
        var self = this,
            data = message;

        if (!self.connection || self.get('readyState') !== 0) {
            self.trigger('error', 'Connection error.');
            return false;
        }

        if (typeof data == 'object') {
            data = JSON.stringify(message);
        }

        if (typeof data != 'string') {
            self.trigger('error', 'Only support json or string.');
            return false;
        }

        Util.debug('[emit] ' + data);
        if (self.get('type') == 'ws') {
            self.connection.send(data);
        } else {
            //目前只支持ping请求
            try {
                new Image().src = '//live.alibaba.com/alipush.io/ping?sid=' + self.get('sid') + '&channel=' + self.get('channel') + '&timestamp=' + new Date().getTime();
            } catch (e) {}
        }
    },
    addEventListeners: function() {
        var self = this;

        self.connection.onopen = function() {
            self.onOpen();
        };
        self.connection.onclose = function() {
            self.onClose();
        };
        self.connection.onmessage = function(event) {
            self.onData(event.data);
        };
        self.connection.onerror = function(error) {
            self.onError(error);
        };
    },
    onOpen: function() {
        this.set('readyState', 1);

        var state = this.getLinkState();
        this.trigger('open', state);
    },
    onClose: function() {
        this.set('readyState', 2);

        var state = this.getLinkState();
        this.trigger('close', state);
    },
    onError: function(error) {
        Util.debug('[error] ' + error);
        this.trigger('error', {
            code: 500,
            msg: 'System error',
            error: error
        });
    },
    onData: function(stream) {
        var self = this;

        if (typeof stream != 'string') {
            self.trigger('error', 'Stream error.');
            return false;
        }

        var code = stream.substring(0, 1),
            data = stream.substring(1);

        try {
            // data {bid: '', body: ''}
            data = JSON.parse(data);
        } catch (e) {}

        switch (code) {
            case '0': // open
                self.set('readyState', 0);
                self.set('sid', data.sid);
                self.set('channel', data.channel);
                self.set('pingInterval', data.pingInterval);
                self.set('heartTime', new Date().getTime());
                self.trigger('heart', '');
                self.polling();
                break;
            case '1': // ping
                break;
            case '2': // pong
                self.set('heartTime', new Date().getTime());
                self.trigger('heart', '');
                break;
            case '3': // message
                if (!(data && data.msgId && data.bid)) {
                    self.trigger('error', {
                        code: 500,
                        msg: 'Message error'
                    });
                    return false;
                }

                // 屏蔽重复消息
                if (self.get('prevMsgId') == data.msgId) {
                    return false;
                }
                self.set('prevMsgId', data.msgId);

                // 发送回执
                try {
                    new Image().src = '//live.alibaba.com/alipush.io/ack?uid=' + self.get('uid') + '&bid=' + data.bid + '&from=' + data.from + '&msgId=' + data.msgId + '&timestamp=' + new Date().getTime();
                } catch (e) {}

                // 触发消息
                self.trigger('message', data);
                break;
            default: //未知或者保留system id
                break;
        }
    },
    getLinkState: function() {
        return this.attrs;
    },
    polling: function() {
        var self = this,
            pingInterval = Number(self.get('pingInterval')),
            heartTime = self.get('heartTime');

        // 重试两次没检测到心跳后断开
        setTimeout(function() {
            if (new Date().getTime() - self.get('heartTime') > 2 * pingInterval) {
                self.close();
            } else {
                self.emit('1ping');
                self.polling();
            }
        }, pingInterval);
    }
});

module.exports = AlipushClient;